/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Upload_ScanInputs */

const en_homepage_features_upload_scan = /** @type {(inputs: Homepage_Features_Upload_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Physical pages`)
};

const es_homepage_features_upload_scan = /** @type {(inputs: Homepage_Features_Upload_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escanear páginas físicas`)
};

/**
* | output |
* | --- |
* | "Scan Physical pages" |
*
* @param {Homepage_Features_Upload_ScanInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_upload_scan = /** @type {((inputs?: Homepage_Features_Upload_ScanInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Upload_ScanInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_upload_scan(inputs)
	return en_homepage_features_upload_scan(inputs)
});